import { render, staticRenderFns } from "./govermentList.vue?vue&type=template&id=869504b2&scoped=true&"
import script from "./govermentList.vue?vue&type=script&lang=js&"
export * from "./govermentList.vue?vue&type=script&lang=js&"
import style0 from "./govermentList.vue?vue&type=style&index=0&id=869504b2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869504b2",
  null
  
)

export default component.exports